import React, { useEffect, useState } from 'react';

import { ENVS, getEnv } from '@adsk/acs-sc-web-platform-api';
import { Box } from '@adsk/alloy-react-box';

const EnvLabel = () => {
  const [envLabel, setEnvLabel] = useState('');

  useEffect(() => {
    const env = getEnv();
    if (env !== ENVS.PRODUCTION) {
      setEnvLabel(env);
    }
  }, []);

  return envLabel ? (
    <Box
      position="fixed"
      padding="0 5px"
      lineHeight="24px"
      fontSize="14px"
      left="50%"
      bg="green500"
      color="white"
    >
      {envLabel}
    </Box>
  ) : null;
};

EnvLabel.displayName = 'EnvLabel';

export default EnvLabel;
